var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10 0C4.47768 0 0 4.47768 0 10C0 15.5223 4.47768 20 10 20C15.5223 20 20 15.5223 20 10C20 4.47768 15.5223 0 10 0ZM14.8058 7.53795C14.8125 7.64286 14.8125 7.75223 14.8125 7.85938C14.8125 11.1362 12.317 14.9107 7.7567 14.9107C6.35045 14.9107 5.04688 14.5022 3.94866 13.7991C4.14955 13.8214 4.34152 13.8304 4.54688 13.8304C5.70759 13.8304 6.77455 13.4375 7.625 12.7723C6.53571 12.75 5.62054 12.0357 5.30804 11.0536C5.68973 11.1094 6.03348 11.1094 6.42634 11.0089C5.86546 10.895 5.36133 10.5904 4.99959 10.1468C4.63785 9.70331 4.44082 9.14823 4.44196 8.57589V8.54464C4.77009 8.72991 5.15625 8.84375 5.56027 8.85938C5.22063 8.63302 4.94209 8.32636 4.74936 7.96658C4.55662 7.60681 4.45563 7.20503 4.45536 6.79688C4.45536 6.33482 4.57589 5.91295 4.79241 5.54688C5.41496 6.31325 6.19181 6.94005 7.07247 7.38653C7.95312 7.83301 8.91788 8.08918 9.90402 8.13839C9.55357 6.45313 10.8125 5.08929 12.3259 5.08929C13.0402 5.08929 13.683 5.38839 14.1362 5.87054C14.6964 5.76562 15.2321 5.5558 15.7098 5.27455C15.5246 5.84821 15.1362 6.33259 14.6205 6.63839C15.1205 6.58482 15.6027 6.44643 16.0491 6.25223C15.7121 6.74777 15.2902 7.1875 14.8058 7.53795Z",
    fill: "#948FB5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter1);
export default __webpack_public_path__ + "static/media/twitter1.9110ba3ee9cdf9fb80f31e1181b326a3.svg";
export { ForwardRef as ReactComponent };